import { Button } from "@/components/ui/button";
import { useBreadcrumbs } from "@/lib/use-breadcrumbs";
import { cn } from "@/lib/utils";
import {
	Link,
	Outlet,
	createFileRoute,
	useLocation,
} from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/settings/plugins")({
	component: PluginsLayout,
});

function PluginsLayout() {
	const { t } = useTranslation("settings");
	useBreadcrumbs([
		{ label: t("breadcrumb_settings"), href: "/settings" },
		{ label: t("plugins_breadcrumb") },
	]);

	const location = useLocation();
	const currentPath = location.pathname;

	const tabs = [
		{ label: t("plugins_tab_installed"), href: "/settings/plugins" },
		{
			label: t("plugins_tab_marketplace"),
			href: "/settings/plugins/marketplace",
		},
		{ label: t("plugins_tab_developer"), href: "/settings/plugins/developer" },
	];

	return (
		<div>
			<div className="flex items-center gap-2 px-4 py-2 shrink-0 justify-end">
				<Button
					variant="outline"
					size="sm"
					className="h-9"
					onClick={() => window.location.reload()}
				>
					{t("refresh", { defaultValue: "Обновить" })}
				</Button>
			</div>
			<nav className="-mx-6 -mt-4 flex border-b bg-muted/30">
				{tabs.map((tab) => {
					const isActive =
						tab.href === "/settings/plugins"
							? currentPath === "/settings/plugins"
							: currentPath.startsWith(tab.href);

					return (
						<Link
							key={tab.href}
							to={tab.href}
							className={cn(
								"px-5 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors",
								isActive
									? "border-primary text-foreground bg-background"
									: "border-transparent text-muted-foreground hover:text-foreground",
							)}
						>
							{tab.label}
						</Link>
					);
				})}
			</nav>

			<div className="pt-5">
				<Outlet />
			</div>
		</div>
	);
}
